export const awsConfig = {
    project_region: process.env.REACT_APP_AWS_COGNITO_REGION,
    user_pool_id: process.env.REACT_APP_AWS_COGNITO_POOL_ID,
    user_client_id: process.env.REACT_APP_AWS_COGNITO_CLIENT_ID
}
